export default __webpack_public_path__ + "static/media/Phonk-Regular-DEMO.411157e1.otf";